import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/bestdentistsurat.com/src/components/pages/patient-gallery/index.jsx");
